import { render, staticRenderFns } from "./InvoiceLinkGroupsDialog.vue?vue&type=template&id=5711b6e8&scoped=true"
import script from "./InvoiceLinkGroupsDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceLinkGroupsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5711b6e8",
  null
  
)

export default component.exports